import { LorebookVisibility } from "@next-platform/packages-ts-types";
import { useCallback, useRef, useState } from "react";
export default function useLorebookVisibilityConfirmation({ lorebook, value, onChange, disabled = false }) {
    const [statePendingLorebookId, setStatePendingLorebookId] = useState();
    const refHasPendingConfirmation = useRef(false);
    const lorebookId = lorebook?.id;
    // Public approval preserves PRIVATE/HIDDEN until publication; auto-moderation status does not track publication approval.
    const isConfirmationEligible = !disabled && Boolean(lorebookId) && lorebook?.visibility === LorebookVisibility.PUBLIC && value === LorebookVisibility.PUBLIC;
    const isConfirmationOpen = statePendingLorebookId !== undefined && statePendingLorebookId === lorebookId && isConfirmationEligible;
    if (statePendingLorebookId !== undefined && !isConfirmationOpen) {
        setStatePendingLorebookId(undefined);
    }
    const onDismiss = useCallback(() => {
        refHasPendingConfirmation.current = false;
        setStatePendingLorebookId(undefined);
    }, []);
    const onVisibilityChange = useCallback((visibility) => {
        if (disabled)
            return;
        if (isConfirmationEligible && visibility === LorebookVisibility.PRIVATE) {
            refHasPendingConfirmation.current = true;
            setStatePendingLorebookId(lorebookId);
            return;
        }
        onDismiss();
        onChange(visibility);
    }, [disabled, isConfirmationEligible, lorebookId, onChange, onDismiss]);
    const onConfirm = useCallback(() => {
        if (!isConfirmationOpen || !refHasPendingConfirmation.current) {
            return;
        }
        onDismiss();
        onChange(LorebookVisibility.PRIVATE);
    }, [isConfirmationOpen, onChange, onDismiss]);
    return { isConfirmationOpen, onVisibilityChange, onConfirm, onDismiss };
}
